import React, { useState, useEffect } from "react";
import { TextField, MenuItem, useTheme, } from "@mui/material";
import { useLoadScript } from "@react-google-maps/api";
import SourceDestination from "../components/booking/common/SourceDestination";
import { AppContext } from "../components/services/AppContext";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import "../styles/commonStyle.css";
import CarModelSelector from "../components/booking/common/CarModelSelector";
import { RequestBookingService } from "../components/services/RequestBookingService"
import Cookies from 'js-cookie';




const libraries: "places"[] = ["places"];

interface Form2Props {
  formValues: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleNext: () => void;
  handleBack: () => void;
}

const NewBookingForm2: React.FC<Form2Props> = ({ formValues, handleInputChange, handleNext, handleBack, }) => {

  const { isLoaded } = useLoadScript({
    // googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "", // Use environment variable for API key
    googleMapsApiKey: "AIzaSyC-vagKdGDTclItg8HzxXIGw_8NlVo6NOc",
    libraries: libraries,
  });

  const isLoggedIn = Boolean(Cookies.get('loggedUserId'));

  //const navigate = useNavigate();
  const theme = useTheme();
  const [booking, setBooking] = useState(RequestBookingService.getRequestBooking().booking);
  const [loading, setLoading] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedCarModel, setSelectedCarModel] = useState(false)


  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleCarModel = async (carModel: string) => {
    setSelectedCarModel(true)
    RequestBookingService.getRequestBooking().booking.selectedCarModel = carModel
    await RequestBookingService.calculateFare()
    setBooking({ ...RequestBookingService.getRequestBooking().booking });
    // console.log("booking.selectedCarModel " + booking.selectedCarModel)
  };

  const handlePassengerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const passengers = parseInt(e.target.value)
    handleInputChange(e);
    RequestBookingService.getRequestBooking().booking.numberOfPassengers = passengers
  };
  const handleBigBagChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const bigBags = parseInt(e.target.value)
    handleInputChange(e);
    RequestBookingService.getRequestBooking().booking.numberOfBigBags = bigBags
  };

  const handleNextClicked = async () => {
    // console.log("handleNextClicked")

    if (!RequestBookingService.getRequestBooking().booking.numberOfPassengers) {
      setSnackbarMessage("Please select number of passengers");
      setSnackbarOpen(true);
      return;
    }
    if (!RequestBookingService.getRequestBooking().booking.numberOfBigBags) {
      setSnackbarMessage("Please select number of bags bigs.");
      setSnackbarOpen(true);
      return;
    }
    RequestBookingService.getRequestBooking().booking.selectedCarModel = AppContext.selectedCar.carModel
    await RequestBookingService.calculateFare()
    handleNext();
  };

  const getDiscountImage = (discountType: string) => {
    switch (discountType) {
      case "firstTimeBooking":
        return "../images/discount/discount-2.jpg";
      case "LastMinuteFare":
        return "../images/discount/discount-3.jpg";
      default:
        return "../images/discount/discount-1.jpg";
    }
  }
  const imageSrc = `${getDiscountImage(booking.status)}?v=${booking.status}`;

  //   console.log("Booking status:", booking.status);
  // console.log("Image source:", getDiscountImage(booking.status));

  if (!isLoaded) return <div>Loading...</div>;
  return (
    <div>
      <div className="container">
        <div className="row gx-1 gx-sm-2 gx-md-3 gy-1">
          <div className="col-12">
            <SourceDestination
              source={RequestBookingService.getSourceFormattedAddress()}
              destination={RequestBookingService.getDestinationFormattedAddress()}
            />
          </div>
        </div>
        <div className="w-100">
          <img
            src={imageSrc}
            alt={booking.status}
            className="w-100 mb-3"
            loading="lazy"
          />
        </div>
        <CarModelSelector onPress={handleCarModel} />

        <div className="row">
          <div className="col-12">
            <TextField
              select
              label="Number Of Passengers"
              fullWidth
              name="numberOfPassengers"
              value={RequestBookingService.getRequestBooking().booking.numberOfPassengers.toString()}
              onChange={handlePassengerChange}
              required
              //type="number"
              sx={{ bgcolor: "white", borderRadius: 1, mt: 2, textAlign: "left" }}
            >
              <MenuItem value="0">0</MenuItem>
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
              <MenuItem value="5">5</MenuItem>
              <MenuItem value="6">6</MenuItem>
              <MenuItem value="7">7</MenuItem>
            </TextField>
          </div>

          <div className="col-12">
            <TextField
              select
              label="Number Of Big Bags"
              fullWidth
              name="numberOfBigBags"
              value={RequestBookingService.getRequestBooking().booking.numberOfBigBags.toString()}
              onChange={handleBigBagChange}
              required
              //type="number"
              sx={{ bgcolor: "white", borderRadius: 1, mt: 2, textAlign: "left" }}
            >
              <MenuItem value="0">0</MenuItem>
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
              <MenuItem value="5">5</MenuItem>
              <MenuItem value="6">6</MenuItem>
              <MenuItem value="7">7</MenuItem>
            </TextField>
          </div>

          <div className="col-12">
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={2000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              className="snackbarPosition"
              aria-live="assertive"
            >
              <Alert onClose={handleCloseSnackbar} severity="error">
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </div>
          <br />
          <div className="col-6">
            <button
              type="button"
              className="btn w-100 back-button"
              onClick={handleBack}
            >
              Back
            </button>
          </div>

          <div className="col-6">
            <button
              type="button"
              className="btn w-100 primary-button"
              onClick={handleNextClicked}
            >
              Next
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default NewBookingForm2;
